import { Box, Container, Heading, HStack, Image } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import { usePageHeader } from '#src/providers/page-layout-provider';
import { useSidebar } from '#src/providers/sidebar-provider';

export function PageHeader() {
  const { title, actionsRef } = usePageHeader();
  const { onOpen } = useSidebar();
  const { pathname } = useLocation();
  const isDocumentRoute =
    pathname === '/documents' || pathname.startsWith('/documents/');

  return (
    <Box
      position="sticky"
      top={0}
      zIndex={10}
      bg={isDocumentRoute ? 'var(--background-base-color)' : 'bg'}
      shadow={isDocumentRoute ? 'none' : 'sm'}
      borderBottomWidth={isDocumentRoute ? 'var(--border-base-width)' : '1px'}
      borderColor={isDocumentRoute ? 'var(--border-base-color)' : 'border'}
      mb={isDocumentRoute ? 0 : 2}
      width="100%"
    >
      <Container maxW="container.xl" px={4} py={3}>
        <HStack justify="space-between" align="center" gap={4}>
          <HStack gap={3} align="center" flex={1} minW={0}>
            {/* Site logo — toggles sidebar */}
            <Image
              src="/icon.svg"
              alt="Open navigation menu"
              height="32px"
              width="32px"
              cursor="pointer"
              onClick={onOpen}
              flexShrink={0}
            />

            {/* Title */}
            {title != null && (
              <Heading size="lg" color="fg" flex={1} minW={0}>
                {typeof title === 'string' ? title : title}
              </Heading>
            )}
          </HStack>

          {/* Portal target for page actions */}
          <Box ref={actionsRef} flexShrink={0} />
        </HStack>
      </Container>
    </Box>
  );
}
